import { APIClient } from "api/api_helper";
import { AdverseEventAssessment_API } from "api/url_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";

const api = new APIClient();

export const adverseEventAssessmentApiService = {
  getSelectById: (data: any) => {
    return api.create(AdverseEventAssessment_API.AdverseEventAssessment_API + "Select", data);
  },

  updateData: (data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...data,
      updatedby: user?.userid,
    };
    return api.create(AdverseEventAssessment_API.AdverseEventAssessment_API + "Update", payload);
  },
};
